/**
 * 判斷目前畫面寬度為哪一種尺寸
 *
 * @returns { isDesktop: 桌機版, isTablet: 平版, isMobile: 行動版, completed: 已完成判斷 }
 */

import { useMediaQuery } from '@vueuse/core';

export function useScreen() {
  // 在 SSR 階段通過 User-Agent 預判設備類型並決定 ssrWidth

  const getSSRWidth = (): number | undefined => {
    if (import.meta.server) {
      try {
        const headers = useRequestHeaders(['user-agent']);
        const userAgent = headers['user-agent'] || '';
        const isMobileUA =
          /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            userAgent
          );
        const isTabletUA = /iPad|tablet|Tablet/i.test(userAgent);

        // 根據 User-Agent 返回對應的模擬寬度
        if (isMobileUA && !isTabletUA) return 375; // 手機
        if (isTabletUA) return 768; // 平板
        return 1440; // 桌機
      } catch (error) {
        console.error('Error detecting device from User-Agent:', error);
        return 1440;
      }
    }
    return undefined;
  };

  const ssrWidth = getSSRWidth();

  // 使用 useMediaQuery 並設定 ssrWidth 避免 hydration mismatch

  const isDesktop = useMediaQuery('(min-width: 1025px)', {
    ssrWidth,
  });
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1024px)', {
    ssrWidth,
  });
  const isMobile = useMediaQuery('(max-width: 767px)', {
    ssrWidth,
  });

  return { isDesktop, isTablet, isMobile };
}
